import React from 'react';
import PropTypes from 'prop-types';
import WhySolarPanels from './WhySolarPanels';


import '../saleslogic.css';
import { Title } from '../styles';
import '../../../../../../grid.css';

const WHYGOSOLAR = (props) => {
    const {
        resiToggle, provider, projectState, firstName, smartValue,
        annualResults, systemSize, cashprice, essToggle, essPrice, taxRate,
        installYear, loanProvider, mosaicFee, selectedFinancing, showLoan,
    } = props;
    let building = 'home';
    if (resiToggle === false) {
        building = 'building';
    }

    let price = cashprice;
    if (essToggle) {
        price = essPrice + cashprice;
    }
    if (selectedFinancing === 2 && essToggle && loanProvider === 'mosaic') {
        price = (essPrice + cashprice) * mosaicFee;
    }
    if (selectedFinancing === 2 && loanProvider === 'mosaic') {
        price = cashprice * mosaicFee;
    }


    const terms = {
        building,
        provider,
        projectState,
        firstName,
        resiToggle,
        smartValue,
        annualResults,
        systemSize,
        price,
        taxRate,
        installYear,
        loanProvider,
        mosaicFee,
        showLoan,
    };

    return (
        <div>
            <Title>Your Financial Benefits Explained</Title>
            <WhySolarPanels terms={terms} />
        </div>
    );
};

WHYGOSOLAR.propTypes = {
    resiToggle: PropTypes.bool.isRequired,
    essToggle: PropTypes.bool.isRequired,
    showLoan: PropTypes.bool.isRequired,
    annualResults: PropTypes.object.isRequired,
    provider: PropTypes.number.isRequired,
    projectState: PropTypes.number.isRequired,
    firstName: PropTypes.string.isRequired,
    smartValue: PropTypes.number.isRequired,
    systemSize: PropTypes.number.isRequired,
    essPrice: PropTypes.number,
    taxRate: PropTypes.number.isRequired,
    cashprice: PropTypes.number.isRequired,
    loanProvider: PropTypes.string.isRequired,
    installYear: PropTypes.number.isRequired,
    mosaicFee: PropTypes.number.isRequired,
    selectedFinancing: PropTypes.number.isRequired,
};

WHYGOSOLAR.defaultProps = {
    essPrice: 0,
};

export default WHYGOSOLAR;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/WHYGOSOLAR/WHYGOSOLAR.js